import { ShieldAlert } from "lucide-react";

/**
 * UnauthorizedAccess - Displayed when user doesn't have permission to access a resource
 */
export const UnauthorizedAccess = ({
  message = "Vous n'avez pas les permissions nécessaires pour accéder à cette ressource.",
  title = "Accès non autorisé",
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-6">
      <div className="alert alert-error max-w-md">
        <ShieldAlert className="w-8 h-8" />
        <div>
          <h3 className="font-bold text-lg">{title}</h3>
          <p className="text-sm">{message}</p>
        </div>
      </div>
    </div>
  );
};
